// @ts-nocheck
/* eslint-disable */
export const monitorIcon = {
        data: `<svg
    class="management-nav-icon"
    viewBox="0 0 100 100"
    fill="none">
 <path
        class="lower-hexagon"
        d="M48.0833 2.83864C49.2694 2.15388 50.7306 2.15388 51.9167 2.83864L89.8846 24.7594C91.0706 25.4442 91.8013 26.7097 91.8013 28.0792V71.9208C91.8013 73.2903 91.0706 74.5558 89.8846 75.2406L51.9167 97.1614C50.7306 97.8461 49.2694 97.8461 48.0833 97.1614L10.1154 75.2406C8.92936 74.5558 8.19873 73.2903 8.19873 71.9208V28.0792C8.19873 26.7097 8.92936 25.4442 10.1154 24.7594L48.0833 2.83864Z"
        stroke-width="3" />
    <g style="mix-blend-mode: soft-light">
        <path
            class="upper-hexagon-shade"
            d="M50 8L87 29.7166V48.2875C87 48.2875 76.7767 57 50 57C24.6328 57 13 48.2875 13 48.2875V30L50 8Z" />
        <path
            d="M14 30.5688L50.0033 9.16146L86 30.2892V47.7954C85.9763 47.8127 85.9514 47.8308 85.9252 47.8495C85.6165 48.0712 85.1369 48.3955 84.474 48.7888C83.1485 49.5752 81.0886 50.6379 78.1951 51.7056C72.4099 53.8403 63.2778 56 50 56C37.4335 56 28.2975 53.8424 22.3246 51.7024C19.3372 50.632 17.1385 49.565 15.6954 48.7724C14.9739 48.376 14.4412 48.0482 14.0932 47.8227C14.0605 47.8015 14.0294 47.7812 14 47.7618V30.5688Z"
            stroke="black"
            stroke-opacity="0.01"
            stroke-width="2" />
    </g>

    <path
        d="M31.1146 68.7626C32.5999 70.2485 35.0189 70.2491 36.5054 68.7626L43.3595 61.9087L44.0144 62.5635C44.2625 62.8116 44.6644 62.8116 44.9126 62.5635L47.3469 60.1294C49.4122 61.1191 51.7234 61.6747 54.162 61.6747C62.8948 61.6747 70 54.5702 70 45.8373C70 37.1045 62.8948 30 54.162 30C45.4335 30 38.332 37.1045 38.332 45.8374C38.332 48.2091 38.8594 50.4589 39.7973 52.4806L37.3135 54.9647C37.0654 55.2128 37.0654 55.6147 37.3135 55.8628L37.9686 56.518L31.1146 63.3718C29.6285 64.8579 29.6285 67.2764 31.1146 68.7626ZM54.162 31.2703C62.1945 31.2703 68.7296 37.8052 68.7296 45.8374C68.7296 53.8696 62.1945 60.4044 54.162 60.4044C46.1338 60.4044 39.6023 53.8695 39.6023 45.8373C39.6023 37.8051 46.1338 31.2703 54.162 31.2703ZM40.4094 53.6649C41.7877 56.0794 43.7812 58.0969 46.1766 59.5034L44.4634 61.2163L38.6608 55.4137L40.4094 53.6649ZM32.0128 64.2699L38.867 57.416L42.4614 61.0105L35.6072 67.8644C34.6154 68.8553 33.0033 68.854 32.0127 67.8644C31.0216 66.8735 31.0216 65.2608 32.0128 64.2699Z"
        stroke="var(--icon-text)"
        stroke="var(--icon-text)"
        stroke-width="0.5" />
    <path
        d="M53.9041 53C53.8877 53 53.8722 53 53.8559 53C50.1021 53 46.5379 50.9004 43.2662 46.7579C42.928 46.3667 42.9084 45.7597 43.2294 45.3186C43.2458 45.292 47.6236 39 54.141 39C57.8833 39 61.4466 41.1099 64.7331 45.2705C65.0738 45.6625 65.0917 46.2721 64.7682 46.7123L64.1212 46.1879L64.7666 46.7149C64.2969 47.3589 60.0089 52.9991 53.9041 53ZM44.7995 46.003C47.6653 49.5058 50.7116 51.2804 53.8591 51.2804C53.873 51.2804 53.8869 51.2804 53.9 51.2804C58.6209 51.2804 62.1615 47.3237 63.1981 46.0228C60.3185 42.5028 57.273 40.7196 54.1401 40.7196C49.3604 40.7196 45.7537 44.8045 44.7995 46.003ZM44.5577 46.3186C44.5536 46.3246 44.5512 46.328 44.5504 46.3289C44.5528 46.3263 44.5553 46.322 44.5577 46.3186Z"
        stroke="var(--icon-text)" />
    <path
        d="M64.1212 46.1879L64.7682 46.7123C65.0917 46.2721 65.0738 45.6625 64.7331 45.2705C61.4466 41.1099 57.8833 39 54.141 39C47.6236 39 43.2458 45.292 43.2294 45.3186C42.9084 45.7597 42.928 46.3667 43.2662 46.7579C46.5379 50.9004 50.1021 53 53.8559 53C53.8722 53 53.8877 53 53.9041 53C60.0089 52.9991 64.2969 47.3589 64.7666 46.7149L64.1212 46.1879ZM64.1212 46.1879L64.769 46.7115M44.7995 46.003C47.6653 49.5058 50.7116 51.2804 53.8591 51.2804C53.873 51.2804 53.8869 51.2804 53.9 51.2804C58.6209 51.2804 62.1615 47.3236 63.1981 46.0228C60.3185 42.5028 57.273 40.7196 54.1401 40.7196C49.3604 40.7196 45.7537 44.8045 44.7995 46.003ZM44.5577 46.3186C44.5536 46.3246 44.5512 46.328 44.5504 46.3289C44.5528 46.3263 44.5553 46.322 44.5577 46.3186Z"
        stroke="var(--icon-text)"
        stroke-width="0.5" />
    <path
        d="M53.9846 49C53.3589 49 52.686 48.804 52.0291 48.3281C51.8991 48.2335 51.7801 48.1152 51.685 47.9856C50.5699 46.4558 50.9587 44.8433 51.8383 43.9241C52.7216 43.0011 54.3925 42.5283 55.9713 43.6724C56.1007 43.7657 56.2197 43.884 56.3148 44.0143C57.4306 45.5453 57.0417 47.1577 56.1615 48.0764C55.6462 48.6149 54.8617 49 53.9846 49ZM54.003 44.2516C53.484 44.2516 53.0271 44.4745 52.7155 44.7995C52.2376 45.298 51.9389 46.236 52.6689 47.2373C52.6873 47.2623 52.713 47.2886 52.7388 47.3068C53.7361 48.0288 54.736 47.7733 55.2843 47.2003C55.7621 46.7012 56.0609 45.7638 55.3309 44.7626C55.3132 44.7375 55.2868 44.7118 55.2616 44.6937L55.261 44.6931C54.8304 44.3812 54.3986 44.2516 54.003 44.2516Z"
        stroke="var(--icon-text)"
        stroke="var(--icon-text)"
        stroke-width="0.5" />


      <defs>
        <linearGradient
            id="paint0_linear_dark"
            x1="48.4375"
            y1="3.125"
            x2="73.4375"
            y2="87.5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#E5E6E6" />
            <stop
                offset="0.46875"
                stop-color="#4FC8EC" />
            <stop
                offset="1"
                stop-color="#2D3792" />
        </linearGradient>
        <linearGradient
            id="paint1_linear_dark"
            x1="50"
            y1="100"
            x2="50"
            y2="7.11531e-07"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#2D3792" />
            <stop
                offset="1"
                stop-color="#4FC8EC" />
        </linearGradient>
        <linearGradient
            id="paint2_linear_dark"
            x1="48.5908"
            y1="7.99662"
            x2="60.3796"
            y2="64.1636"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#E5E6E6" />
            <stop
                offset="0.46875"
                stop-color="#ADAFB1" />
            <stop
                offset="1"
                stop-color="#CCCDCF" />
        </linearGradient>

        <linearGradient
            id="paint0_linear_light"
            x1="48.4375"
            y1="3.125"
            x2="73.4375"
            y2="87.5"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#E5E6E6" />
            <stop
                offset="0.46875"
                stop-color="#1D53A4" />
            <stop
                offset="1"
                stop-color="#1C3664" />
        </linearGradient>
        <linearGradient
            id="paint1_linear_light"
            x1="50"
            y1="100"
            x2="50"
            y2="7.11531e-07"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#1C3664" />
            <stop
                offset="1"
                stop-color="#1D53A4" />
        </linearGradient>
        <linearGradient
            id="paint2_linear_light"
            x1="48.5908"
            y1="7.99662"
            x2="60.3796"
            y2="64.1636"
            gradientUnits="userSpaceOnUse">
            <stop stop-color="#E5E6E6" />
            <stop
                offset="0.46875"
                stop-color="#ADAFB1" />
            <stop
                offset="1"
                stop-color="#CCCDCF" />
        </linearGradient>
    </defs>
</svg>
`,
name: 'monitor' as const
};